import { ArrowLeft, ArrowRight, Sparkles } from "lucide-react";

type Props = {
  orgId: string;
  onContinue: () => void;
  onBack: () => void;
};

export function StepDesignPartner({ onContinue, onBack }: Props) {
  return (
    <section className="space-y-10">
      <div className="space-y-4">
        <span
          className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider text-ink"
          style={{
            backgroundColor: "#F5EDE0",
            border: "1px solid rgba(200,169,81,0.35)",
          }}
        >
          <Sparkles className="w-3.5 h-3.5" />
          Design partner
        </span>
        <h1 className="text-5xl sm:text-7xl font-black tracking-tight text-ink leading-[1.05]">
          Eres uno de
          <br />
          nuestros design
          <br />
          partners 🎉
        </h1>
        <p className="text-base sm:text-lg text-ink-2 max-w-xl">
          Gracias por confiar en nosotros desde el principio. Como design
          partner formas parte de un grupo reducido de clientes que nos ayuda a
          dar forma al producto.
        </p>
      </div>

      <ul className="space-y-4 max-w-xl">
        <Bullet
          title="Acceso temprano"
          body="Estrenas las novedades antes que nadie y participas en betas privadas."
        />
        <Bullet
          title="Línea directa con los fundadores"
          body="Canal abierto para proponer mejoras, integraciones o cambios de roadmap."
        />
        <Bullet
          title="Tu feedback da forma al producto"
          body="Lo que pidas se prioriza si encaja con la visión."
        />
      </ul>

      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1 text-sm text-ink-2 hover:text-ink transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Atrás
        </button>
        <button
          type="button"
          onClick={onContinue}
          className="inline-flex items-center gap-2 bg-ink text-white text-base font-semibold px-6 py-3 rounded-full transition-all duration-200 hover:scale-[1.02]"
        >
          Continuar
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
}

function Bullet({ title, body }: { title: string; body: string }) {
  return (
    <li className="flex items-start gap-3">
      <span
        className="mt-2 w-2 h-2 rounded-full shrink-0"
        style={{ backgroundColor: "#C8A951" }}
      />
      <div>
        <div className="text-base font-semibold text-ink">{title}</div>
        <div className="text-sm text-ink-2">{body}</div>
      </div>
    </li>
  );
}
